module.exports = __webpack_public_path__ + "static/media/panankrabi.0a004d1d.png";